import { render, staticRenderFns } from "./paymhistory.vue?vue&type=template&id=0adf4b38&"
import script from "./paymhistory.vue?vue&type=script&lang=js&"
export * from "./paymhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports